// extracted by mini-css-extract-plugin
export default {"container":"SearchResults_container__DCvZf","left":"SearchResults_left__4iqlk","right":"SearchResults_right__G0f+Z"};